import { useTranslation } from 'react-i18next';
import { object, number, array, string } from 'yup';

import { yupFile } from '@utils/yup';

import { FormValues, MemberFormValues } from './type';

export const useFormValues = () => {
  const memberValues: MemberFormValues = {
    premium: '',
    discountPremium: ''
  };
  const values: FormValues = {
    me: memberValues,
    spouse: { ...memberValues, allowUndefined: true },
    daughters: [memberValues],
    sons: [memberValues],
    adminFeeAmount: '',
    note: '',
    proof: undefined,
  };
  return values;
};

export const useValidationSchema = () => {
  const { t } = useTranslation();

  const memberSchema = object({
    premium: number().required(t('validation:required')),
    discountPremium: number().required(t('validation:required')),
  });

  return object({
    proof: yupFile().required(t('validation:required')),
    note: string().required(t('validation:required')),
    me: memberSchema.required(t('validation:required')),
    spouse: memberSchema.optional().default(undefined),
    sons: array().of(memberSchema).optional(),
    daughters: array().of(memberSchema).optional(),
    adminFeeAmount: number().required(t('validation:required')),
  });
};
